import Image from "next/image";
import Link from "next/link";
import React from "react";
import { useAnalytics } from "~/components/Analytics";
import { ContentItem } from "~/components/ContentItem";
import { Divider } from "~/components/Divider";
import { ReportHorizontalEvent } from "~/components/ReportLibraryHorizontalPage/reportLibraryHorizontalEvents";
import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { Body, Headline } from "~/ui-library";

export type LatestReport = {
  month: string;
  day: string;
  title: string;
  category: string;
  imageSrc: string;
  isChartPack?: boolean;
  href: string;
};

export type ReportLibraryHorizontalLatestProps = {
  latestReports: LatestReport[];
};

export const ReportLibraryHorizontalLatest: React.FC<
  ReportLibraryHorizontalLatestProps
> = ({ latestReports }) => {
  const { analyticsEnhancedTrack } = useAnalytics();

  const onReportClick = ({ title }: LatestReport) =>
    analyticsEnhancedTrack(ReportHorizontalEvent.LatestReportClicked, {
      reportName: title,
    });
  return (
    <>
      {latestReports.map((report, idx) => (
        <React.Fragment key={idx}>
          <div className="flex py-s">
            <div className="my-s mr-m flex">
              <div>
                <Body size="extraSmall" className="uppercase">
                  {report.month}
                </Body>
                <Headline as="div" level={6}>
                  {report.day}
                </Headline>
              </div>
            </div>
            <div className="grow">
              <ContentItem
                eyebrow={heDecodeOrDefault(report.category)}
                headline={heDecodeOrDefault(report.title)}
                headlineHref={report.href}
                isChartPack={report.isChartPack}
                onHeadlineClick={() => onReportClick(report)}
              />
            </div>

            {report.imageSrc ? (
              <Link aria-label="View report" href={report.href}>
                <Image
                  className="ml-m min-w-[116px]"
                  src={report.imageSrc}
                  alt={""}
                  width={116}
                  height={64}
                />
              </Link>
            ) : null}
          </div>
          <Divider containerClassName="last:hidden" />
        </React.Fragment>
      ))}
    </>
  );
};
